import { render, staticRenderFns } from "./video-update.vue?vue&type=template&id=4a2a9de0&scoped=true&"
import script from "./video-update.vue?vue&type=script&lang=js&"
export * from "./video-update.vue?vue&type=script&lang=js&"
import style0 from "./video-update.vue?vue&type=style&index=0&lang=less&"
import style1 from "./video-update.vue?vue&type=style&index=1&id=4a2a9de0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2a9de0",
  null
  
)

export default component.exports